import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../Context';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress, Fade, Snackbar, IconButton } from '@material-ui/core';
import VimmaDrawer from '../../Components/Drawer';
import Profile from '../../Components/Profile';
import Campaigns from '../../Components/Campaigns';
import CampaignDetails from '../../Components/CampaignDetails';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PaymentMethods from '../PaymentMethods';

const styles = (theme) => ({
	progress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -12,
		marginLeft: -12
	},
	toolbar: theme.mixins.toolbar,
	content: {
		flexGrow: 1,
		width: '100%'
	},
	icon: {
		fontSize: 20,
		opacity: 0.9,
		marginRight: theme.spacing.unit
	}
});

class Root extends Component {
	constructor() {
		super();
		this.state = {
			drawerOpen: true
		};

		this.handleDrawer = this.handleDrawer.bind(this);
	}

	componentDidMount() {
		this.context.actions.getUserProfile();
	}

	logout() {
		this.context.actions.logout();
	}

	handleDrawer() {
		this.setState({ drawerOpen: !this.state.drawerOpen });
	};

	handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		this.context.actions.setState({ globalMessage: null });
	};

	render() {
		const { classes, match } = this.props;

		let child = (<Campaigns />);

		if (match.path === '/account') {
			child = (<Profile />);
		} else if (match.path === '/account/payment-methods') {
			child = (<PaymentMethods />);
		} else if (match.path === "/campaigns/:campaignId" && match.params.campaignId && this.context.state.campaigns) {
			const matchedCampaign = this.context.state.campaigns.find((c) => c._id === match.params.campaignId);

			if (matchedCampaign) {
				child = (<Fade><CampaignDetails campaign={matchedCampaign} /></Fade>);
			}
		}

		return (
			<div>
				{this.context.state.user ? (
					<div style={{ display: 'flex' }}>
						<Snackbar
							anchorOrigin={{
								vertical: 'top',
								horizontal: 'center',
							}}
							open={this.context.state.globalMessage}
							autoHideDuration={3000}
							onClose={this.handleSnackbarClose}
							ContentProps={{
								'aria-describedby': 'Success message',
							}}
							message={
								<span id="message-id" style={{ display: 'flex' }}>
									<CheckCircleIcon className={classes.icon} />
									{this.context.state.globalMessage}
								</span>

							}
							action={[
								<IconButton
									key="close"
									aria-label="Close"
									color="inherit"
									onClick={this.handleSnackbarClose}
								>
									<CloseIcon />
								</IconButton>
							]}
						/>
						<VimmaDrawer open={this.state.drawerOpen} />
						<main className={classes.content}>
							<div className={classes.toolbar} />
							{child}
						</main>
					</div>
				) : (<CircularProgress size={24} className={classes.progress} />)}
			</div>
		);
	}
}
Root.contextType = Context;
Root.propTypes = {
	"classes": PropTypes.object.isRequired
};
export default withStyles(styles)(Root);
